import React, { useEffect, useState  } from 'react';
import "./QrMenuPage.css"
import ShowOrders from '../ShowOrdersModal/ShowOrders';


const QrManuPage = ({ subCatas }) => {
   
    const [mainCategories, setMainCategories] = useState([]);
    const [cataTypes, setCataTypes] = useState([]);
    const [subCata, setSubCata] = useState([]);
    const [itemMaster, setItemMaster] = useState([]);
    const storedItems  = JSON.parse(localStorage.getItem("outletdataLocal")) || [];
    const custId = JSON.parse(localStorage.getItem("loginDetails"))?.customerId || null;
    console.log("custid:", custId);

 

    useEffect(() => {

        setMainCategories(JSON.parse(localStorage.getItem("mainCategories")) || []); // Parse string to array
        setCataTypes(JSON.parse(localStorage.getItem("cataTypes")) || [])
        setSubCata(JSON.parse(localStorage.getItem("subCata")) || [])
        setItemMaster(JSON.parse(localStorage.getItem("itemMaster")) || [])
    }, []);

    const getLocalData = (key) => {
        try {
            const data = localStorage.getItem(key);
            return data ? JSON.parse(data) : null;
        } catch (error) {
            console.error("Error getting localStorage data", error);
            return null;
        }
    };

    const setLocalData = (key, value) => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error("Error setting localStorage data", error);
        }
    };




    const [mainCategoryId, setMainCategoryId] = useState(1);

    const [selectedCataTypeId, setSelectedCataTypeId] = useState(99);
    const [activeAccordionIndex, setActiveAccordionIndex] = useState(null); // Track expanded accordion

  


    const API_BASE_URL = process.env.REACT_APP_API_KEY;



    const [selectedItems, setSelectedItems] = useState(getLocalData("selectedItems") || []);
    const [selectedItemsCount, setSelectedItemsCount] = useState(selectedItems.length);

    const totals = selectedItems.reduce(
        (acc, item) => {
            acc.totalQty += item.Qty;
            acc.totalAmount += item.Amount;
            return acc;
        },
        { totalQty: 0, totalAmount: 0 }
    );

    const uniqueSubCataIds = [...new Set(selectedItems.map(item => item.subCataId))];





    const handleQtyChange = (item, change) => {
        const updatedItemMaster = itemMaster.map((itm) => {
            if (itm.qrItemId === item.qrItemId) {
                const newQty = (itm.Qty || 0) + change;
                const updatedQty = newQty >= 0 ? newQty : 0;
                return { ...itm, Qty: updatedQty };
            }
            return itm;
        });

        setItemMaster(updatedItemMaster);

        const updatedItem = updatedItemMaster.find(itm => itm.qrItemId === item.qrItemId);
        const rate = updatedItem.rateApply === 0 ? 0 : parseFloat(updatedItem.rateApply); // Handle "APS" if needed

        let updatedSelectedItems = [...selectedItems];

        if (updatedItem.Qty > 0) {
            const existingIndex = selectedItems.findIndex(itm => itm.qrItemId === updatedItem.qrItemId);
            const selectedItemData = {
                outletId: outletId,
                rmsItemId: updatedItem.rmsItemId,
                qrItemId: updatedItem.qrItemId,
                qrItemName: updatedItem.qrItemName,
                ApplayRate: rate,
                Qty: updatedItem.Qty,
                Amount: updatedItem.Qty * rate,
                subCataId: updatedItem.subCataId
            };

            if (existingIndex >= 0) {
                updatedSelectedItems[existingIndex] = selectedItemData;
            } else {
                updatedSelectedItems.push(selectedItemData);
            }
        } else {
            updatedSelectedItems = selectedItems.filter(itm => itm.qrItemId !== updatedItem.qrItemId);
        }

        setSelectedItems(updatedSelectedItems);
        setLocalData("selectedItems", updatedSelectedItems);
        setSelectedItemsCount(updatedSelectedItems.length);
    };

    const clearSelectedItems = () => {
        const resetItems = itemMaster.map(item => ({ ...item, Qty: 0 }));
        setItemMaster(resetItems);
        setSelectedItems([]);
        setSelectedItemsCount(0);
        setLocalData("selectedItems", []);
        console.log("Selected items cleared!");
    };




    useEffect(() => {
        const localSelectedItems = getLocalData("selectedItems") || [];

        if (localSelectedItems.length > 0 && itemMaster.length > 0) {
            const updatedItemMaster = itemMaster.map(item => {
                const matchedLocalItem = localSelectedItems.find(localItem => localItem.qrItemId === item.qrItemId);

                if (matchedLocalItem) {
                    return {
                        ...item,
                        Qty: matchedLocalItem.Qty,
                        Amount: matchedLocalItem.Amount
                    };
                }
                return item;
            });

            setItemMaster(updatedItemMaster);
            setSelectedItems(localSelectedItems);
            setSelectedItemsCount(localSelectedItems.length);
        }
    }, [itemMaster.length]);




    useEffect(() => {
        const localSelectedItems = getLocalData("selectedItems") || [];
    
        if (localSelectedItems.length > 0 && itemMaster.length > 0) {
            const updatedItemMaster = itemMaster.map(item => {
                const matchedLocalItem = localSelectedItems.find(localItem => localItem.qrItemId === item.qrItemId);
    
                if (matchedLocalItem) {
                    return {
                        ...item,
                        Qty: matchedLocalItem.Qty,
                        Amount: matchedLocalItem.Amount
                    };
                }
                return item;
            });
    
            setItemMaster(updatedItemMaster);
            setSelectedItems(localSelectedItems);
            setSelectedItemsCount(localSelectedItems.length);
        }
    }, [itemMaster.length]);
    



    const handleCategoryClick = (mainCategoryId) => {
        setMainCategoryId(mainCategoryId);
    
        if (mainCategoryId > 1) {
            setSelectedCataTypeId(0);
        } else if (mainCategoryId === 1) {
            setSelectedCataTypeId(99); // Automatically select "All"
        }
    
        setActiveAccordionIndex(null); // Collapse all accordions
    };
    

    const toggleAccordion = (index) => {
        setActiveAccordionIndex((prevIndex) => (prevIndex == index ? null : index));
    };

    const handleCataTypeClick = (cataTypeId) => {
        setSelectedCataTypeId(cataTypeId);
    };

    useEffect(() => {
        if (mainCategoryId === 1) {
            setSelectedCataTypeId(99); // Auto-select "All"
        }
    }, [mainCategoryId]);
    

    const storedData = JSON.parse(localStorage.getItem("outletdataLocal")) || {};

    let outletId, outletlogo;

    // Check if storedData is an array or an object
    if (Array.isArray(storedData) && storedData.length > 0) {
        outletId = storedData[0].outletId;
        outletlogo = storedData[0].outletlogo;
    } else if (storedData && typeof storedData === "object") {
        outletId = storedData.outletId;
        outletlogo = storedData.outletlogo;
    }

    // Debugging
    console.log("outletId:", outletId);
    console.log("outletlogo:", outletlogo);

    localStorage.setItem("outletId:", outletId)

   


    return (
        <>
            <div className='container-fluid'>
                <div className='col-md-12'>
                    <div className='row'>

                        <nav className="navbar navbar-light bg-light sticky-top">
                            <div className="container-fluid">

                                <form className="d-flex">
                                    <b className="navbar-brand me-3">
                                        <img src={outletlogo}
                                            width={60}
                                            height={40} alt="" />
                                    </b>


                                </form>
                            </div>
                        </nav>


                        <div className="d-flex flex-nowrap overflow-scroll "
                            style={{
                                scrollbarWidth: "none", // For Firefox
                                msOverflowStyle: "none", // For Internet Explorer and Edge
                            }}
                        >
                            {mainCategories.map((category) => (
                                <div
                                    className="card me-2 MainCataCardStyle"

                                    key={category.id}
                                    onClick={() => handleCategoryClick(category.mainCataId)}
                                >
                                    <img
                                        src={category.mainCataImage}
                                        className="card-img-top MenuImageStyle"
                                        alt={category.mainCataName}

                                    />
                                    <div
                                        className="card-body text-center"
                                        style={{ height: "8px", overflow: "hidden", fontSize: "15px", lineHeight: "1px" }}
                                    >
                                        <b className="card-title">{category.mainCataName}</b>
                                    </div>

                                </div>
                            ))}
                        </div>

                        {mainCategoryId === 1 && (
  <div className="mt-2 cataTypeContainer">
    {/* "All" Button */}
    {cataTypes.length > 0 && (
      <button
        className={`btn cataTypeBtn me-2 ${
          selectedCataTypeId === 99 ? "btn-primary" : "btn-outline-primary"
        }`}
        onClick={() => handleCataTypeClick(99)}
      >
        All
      </button>
    )}

    {/* Other CataTypes */}
    {cataTypes.map((cataType) => (
      <button
        className={`btn cataTypeBtn me-2 ${
          selectedCataTypeId === cataType.cataTypeId
            ? "btn-primary"
            : "btn-outline-primary"
        }`}
        key={cataType.id}
        onClick={() => handleCataTypeClick(cataType.cataTypeId)}
      >
        <span className="cataTypeName">{cataType.cataTypeName}</span>
      </button>
    ))}
  </div>
)}



                        {mainCategoryId && (
                            <div className="accordionScroll">

                                <div className="accordion mt-2" id="accordionParent">
                                    {subCata
                                        .filter((subCataItem) => subCataItem.mainCataId == mainCategoryId) // Filter by mainCategoryId
                                        .filter((subCataItem) =>
                                            itemMaster.some(
                                                (item) =>
                                                    item.subCataId == subCataItem.subCataId &&
                                                (
                                                    selectedCataTypeId != 99
                                                      ? (item.cataTypeId == selectedCataTypeId || item.cataTypeId == 0)
                                                      : (item.cataTypeId != 99)
                                                  )

                                            )
                                        )
                                        // Filter by mainCategoryId
                                        .map((subCatas, index) => {
                                            const isHighlighted = uniqueSubCataIds.includes(subCatas.subCataId); // Check if in list

                                            return (
                                                <div className="accordion-item" key={index}>
                                                    <h2 className="accordion-header" id={`heading-${index}`}>
                                                        <button
                                                            className={`accordion-button subcataAccBtn ${activeAccordionIndex === index ? "" : "collapsed"
                                                                }`}
                                                            type="button"

                                                            // data-bs-toggle="collapse"
                                                            // data-bs-target={`#collapse-${index}`}
                                                            onClick={() => toggleAccordion(index)}
                                                            aria-expanded={activeAccordionIndex === index}
                                                            aria-controls={`collapse-${index}`}
                                                            style={{
                                                                backgroundColor: isHighlighted ? "pink" : "", // Set pink if matched
                                                            }}
                                                        // onClick={() => handleCataTypeClick(0)}
                                                        >
                                                            {subCatas.subCataName}
                                                        </button>
                                                    </h2>
                                                    <div
                                                        id={`collapse-${index}`}
                                                        className={`accordion-collapse collapse ${activeAccordionIndex === index ? "show" : ""
                                                            }`}
                                                        aria-labelledby={`heading-${index}`}
                                                        data-bs-parent="#accordionParent"
                                                    >
                                                        <div className="accordion-body bodyCss">
                                                            {/* Filter and display items based on subCataId */}
                                                            {itemMaster
                                                                .filter((item) => item.subCataId == subCatas.subCataId && 
                                                                // Match subCataId

                                                                    (
                                                    selectedCataTypeId != 99
                                                      ? (item.cataTypeId == selectedCataTypeId || item.cataTypeId == 0)
                                                      : (item.cataTypeId != 99)
                                                  ))

                                                                .map((filteredItem) => (
                                                                    <div key={filteredItem.id} className="item">
                                                                        <div className="d-flex" style={{ fontSize: "15px" }}>
                                                                            <h6 className='qrItemNameStyle'>{filteredItem.qrItemName}</h6>

                                                                            <div className='selectedRateStyle me-2'>
                                                                                {filteredItem.rateApply === 0 ? "APS" : filteredItem.rateApply}
                                                                            </div>
                                                                            {filteredItem.Qty > 0 && (
                                                                                <div className='qtybtn' style={{ backgroundColor: "pink" }}
                                                                                    onClick={() => handleQtyChange(filteredItem, -1)}
                                                                                >
                                                                                    -
                                                                                </div>
                                                                            )}

                                                                            <div className='qtybtn' style={{ fontSize: "16px" }}>
                                                                                {filteredItem.Qty || 0}
                                                                            </div>

                                                                            <div className='qtybtn' style={{ backgroundColor: "lightgreen" }}
                                                                                onClick={() => handleQtyChange(filteredItem, 1)}
                                                                            >
                                                                                +
                                                                            </div>
                                                                            {filteredItem.Qty > 0 && (
                                                                                <div className='qtybtn' style={{ width: "50px", backgroundColor: "white", fontSize: "15px", border: "none" }}>
                                                                                    <b>{filteredItem.Qty && filteredItem.rateApply !== 0
                                                                                        ? filteredItem.Qty * filteredItem.rateApply
                                                                                        : 0}</b>
                                                                                </div>)}
                                                                        </div>

                                                                        {filteredItem.qrItemDescription1 || filteredItem.qrItemDescription2 || filteredItem.qrItemDescription3 && (
                                                                            <div className="pb-2 dscrstyle">
                                                                                {[filteredItem.qrItemDescription1, filteredItem.qrItemDescription2, filteredItem.qrItemDescription3]
                                                                                    .filter((desc) => desc) // Filter out empty descriptions
                                                                                    .map((desc, i) => (
                                                                                        <div key={i}>{desc}</div>
                                                                                    ))}
                                                                            </div>)}
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </div>
                                                </div>)
                                        })}
                                </div>
                            </div>
                        )}
                        <div className='row d-flex fixed-bottom'>
                            
                            <div className='col-3 '>
                                
                            </div>
                            <div className='col-12 d-flex justify-content-between p-1'>
                                <ShowOrders/>
                                <button className='btn btn-danger showbtnCss'
                                    onClick={clearSelectedItems}>
                                    Clear Cart
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default QrManuPage;

